import styled from 'styled-components';

export const DraggableContainer = styled.div<{ $width?: string; $height?: string }>`
  width: ${({ $width }) => $width || '500px'};
  height: ${({ $height }) => $height || '500px'};
  overflow: auto;
  position: relative;
`;

export const DraggableImg = styled.img`
  position: absolute;
  cursor: grab;
  user-select: none;
`;
